// extracted by mini-css-extract-plugin
module.exports = {"mypage_subsc_container":"main_mypage_subsc_container__2ooPi"};